import { useQuery } from '@tanstack/react-query';

import { type StudioDetails } from '~entities/studios/model/types';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const getStudioFromLocationId = async (locationId: string) => {
  const response = await baseAPI.get<{
    studio: StudioDetails;
    token: string;
    imageUrl: string;
  }>(`studios/dashboard/location`, {
    params: {
      locationId,
    },
  });
  return response.data;
};

export const useGetStudioFromLocationId = (
  locationId: string,
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: [KEYS.STUDIO_DETAILS, 'location', locationId],
    queryFn: () => getStudioFromLocationId(locationId),
    enabled: Boolean(locationId) && (options?.enabled ?? true),
  });
};
